import { getRequest, postRequest, logRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  logRequest("Show Customers")
  return getRequest(`customer/get-list/${size || 15}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  logRequest("Show Customer", JSON.stringify(id))
  return getRequest(`customer/edit/${id}`)
}

export async function save(values) {
  logRequest("Save Customer")
  return postRequest(`customer/save`, values)
}

export function remove(values) {
  logRequest("Delete Customer", JSON.stringify(values.values))
  return postRequest(`customer/delete`, values)
}
 